import React from 'react';
import styled from 'styled-components';

const Button = styled.a`
  line-height: 2;
  height: 5rem;
  text-decoration: none;
  display:inline-flex;
  border-radius: 5px;
  border: 1px solid ;
       border-color: #35245B;
  padding: 0.7rem 1rem 0.7rem 1rem;
  font-size: 2rem;
  letter-spacing: 0.6px;
  box-shadow: 0px 1px 2px #35245B;
  transition: 0.3s all linear;
   font-family: "Kode Mono", monospace;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
 
    background-color: #252525;
 border-color: #F5F5F5;
   color: #F5F5F5;
 
  &:hover, &:active, &:focus {
    text-decoration: none;
    box-shadow: 0px 1px 2px 2px #22313f;
    opacity: 0.85;
    color:#35245B;
  }
`;

const Image = styled.img`
  height: 25px;
  width: 25px;
  margin-bottom: 1px;
  box-shadow: none;
  border: none;
  vertical-align: middle;
`;

const Text = styled.span`
  margin-left: 15px;
  font-size: 1.7rem;
  vertical-align: middle;
`;

function Coffee() {
  return (
    <Button target="_blank" href="https://buymeacoffee.com/coffeetex">
      <Image src="https://cdn.buymeacoffee.com/buttons/bmc-new-btn-logo.svg" alt="Buy me a coffee" />
      <Text>Show your support and buy me a coffee</Text>
    </Button>
  );
}

export default Coffee;